import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Renew.css";
import useEscapeToGoBack from "../hooks/useEscapeToGoBack";

const Adjust = () => {
  useEscapeToGoBack();
  const navigate = useNavigate();

  const [mmyy, setMmyy] = useState("");
  const [receiptNo, setReceiptNo] = useState("");
  const [transaction, setTransaction] = useState(null);
  const [error, setError] = useState("");

  // ⬇️ Refs for Enter navigation
  const mmyyRef = useRef(null);
  const receiptRef = useRef(null);

  // Autofocus MMYY on mount
  useEffect(() => {
    requestAnimationFrame(() => {
      mmyyRef.current?.focus();
      mmyyRef.current?.select?.();
    });
  }, []);

  const handleNext = () => {
    if (!transaction) return;

    navigate("/adjust-grant", {
      state: {
        items: transaction.item.split(", "),
        valuation: transaction.valuationAmount,
        weight: transaction.weight,
        principal: transaction.amount,
        remark: transaction.remark,
        grantDate: transaction.grantDate,
        expiryDate: transaction.expiryDate,
        receiptNo: transaction.receiptNo,
        oldReceiptNo: transaction.oldReceiptNo ?? transaction.old_receipt_no ?? "",
      },
    });
  };

  const handleSearch = async () => {
    try {
      const response = await axios.get(
        `https://www.lianfoong.com/api/pawn-transactions/search`,
        { params: { mmyy, receiptNo } }
      );
      setTransaction(response.data);
      setError("");
    } catch (err) {
      setError("Transaction not found!");
      setTransaction(null);
    }
  };

  // (Optional) helpers used in details
  const formatDateDDMMYYYY = (dateString) => {
    const d = new Date(dateString);
    if (isNaN(d)) return "";
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const monthsPassed = (grantDateStr) => {
    const g = new Date(grantDateStr);
    if (isNaN(g)) return 1;
    const t = new Date();
    let m =
      (t.getFullYear() - g.getFullYear()) * 12 + (t.getMonth() - g.getMonth());
    if (m < 1) m = 1;
    return m;
  };

  // ⬇️ Enter key behavior (same as Renew)
  const onMmyyKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      receiptRef.current?.focus();
      receiptRef.current?.select?.();
    }
  };

  const onReceiptKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (transaction) {
        handleNext();
      } else {
        handleSearch();
      }
    }
  };

  return (
    <div className="renew-container">
      <h2 className="title">Adjust Pawn Ticket</h2>

      <div className="form-group">
        <label>Enter Month and Year (MMYY):</label>
        <input
          type="text"
          ref={mmyyRef}
          value={mmyy}
          onChange={(e) => setMmyy(e.target.value)}
          onKeyDown={onMmyyKeyDown}
        />
      </div>

      <div className="form-group">
        <label>Enter Receipt Number:</label>
        <input
          type="text"
          ref={receiptRef}
          value={receiptNo}
          onChange={(e) => setReceiptNo(e.target.value)}
          onKeyDown={onReceiptKeyDown}
        />
      </div>

      <button className="search-btn" onClick={handleSearch}>
        Search
      </button>

      {error && <p className="error-message">{error}</p>}

      {transaction && (
        <div className="transaction-details">
          <div className="details-grid">
            <p>
              <strong>Items:</strong> {transaction.item}
            </p>
            <p>
              <strong>Weight:</strong> {transaction.weight}
            </p>
            <p>
              <strong>Amount:</strong> ${Number(transaction.amount).toFixed(2)}
            </p>
            <p>
              <strong>Month Pass:</strong> {monthsPassed(transaction.grantDate)}
            </p>
            <p>
              <strong>Date:</strong> {formatDateDDMMYYYY(transaction.grantDate)}
            </p>
            <p>
              <strong>Expiry Date:</strong>{" "}
              {formatDateDDMMYYYY(transaction.expiryDate)}
            </p>
          </div>

          <button className="next-btn" onClick={handleNext}>
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default Adjust;
